export const SITE = {
  url: 'https://kassamtradingcompany.com',
  name: 'Kassam Trading Company',
  defaultTitle: 'Rice Exporters in Pakistan | Kassam Trading Company (KTC)',
  defaultDescription:
    "Kassam Trading Company (KTC) is a leading, REAP-registered rice exporter in Pakistan since 1999 — premium 1121 & 1509 basmati, IRRI-6 & PK-386 non-basmati rice, Himalayan Pink Salt, wheat, corn and sesame. FOB Port Qasim, CIF worldwide.",
  ogImage: 'https://kassamtradingcompany.com/og-cover.png',
  linkedin: 'https://www.linkedin.com/company/kassamtradingcompany',
  instagram: 'https://www.instagram.com/ktc.tradingg',
};

const KARACHI_ADDRESS = {
  '@type': 'PostalAddress',
  streetAddress: '601, 6th Floor, UNI Center, I.I Chundrigar Road',
  addressLocality: 'Karachi',
  addressRegion: 'Sindh',
  addressCountry: 'PK',
};

const AREAS = ['AE', 'SA', 'OM', 'IR', 'KE', 'TZ', 'NG', 'GH', 'CI', 'MY', 'PH', 'CN', 'SG', 'NL', 'GB', 'DE', 'CA'];

export const organizationLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': SITE.url + '/#organization',
  name: SITE.name,
  alternateName: 'KTC',
  url: SITE.url,
  logo: SITE.url + '/logo.png',
  image: SITE.ogImage,
  description: SITE.defaultDescription,
  foundingDate: '1999',
  email: 'ktcmktg@gmail.com',
  telephone: '+92-21-32427245',
  address: KARACHI_ADDRESS,
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+92-21-32427245',
      contactType: 'sales',
      email: 'ktcmktg@gmail.com',
      areaServed: AREAS,
      availableLanguage: ['en'],
    },
  ],
  sameAs: [SITE.linkedin, SITE.instagram],
};

export const websiteLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': SITE.url + '/#website',
  name: SITE.name,
  url: SITE.url,
  publisher: { '@id': SITE.url + '/#organization' },
};

export const localBusinessLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': SITE.url + '/#business',
  name: SITE.name,
  image: SITE.ogImage,
  logo: SITE.url + '/logo.png',
  url: SITE.url,
  telephone: '+92-21-32427245',
  email: 'ktcmktg@gmail.com',
  priceRange: '$$',
  address: KARACHI_ADDRESS,
  areaServed: 'Worldwide',
  openingHours: 'Mo-Sa 09:00-18:00',
  sameAs: [SITE.linkedin, SITE.instagram],
};

export const productLd = (p, categoryName) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: p.name,
  image: p.image ? [p.image] : undefined,
  description: p.description || p.short,
  category: categoryName,
  sku: p.slug,
  brand: { '@type': 'Brand', name: SITE.name },
  manufacturer: { '@type': 'Organization', name: SITE.name },
});

export const breadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: SITE.url + it.path,
  })),
});

export const articleLd = (u, imageAbs) => ({
  '@context': 'https://schema.org',
  '@type': 'NewsArticle',
  headline: u.title,
  image: imageAbs ? [imageAbs] : undefined,
  datePublished: u.date,
  author: { '@type': 'Organization', name: SITE.name },
  publisher: {
    '@type': 'Organization',
    name: SITE.name,
    logo: { '@type': 'ImageObject', url: SITE.url + '/logo.png' },
  },
  mainEntityOfPage: SITE.url + '/updates/' + u.slug,
  description: (u.body || '').slice(0, 160),
});

export const faqs = [
  {
    q: 'What products does Kassam Trading Company export?',
    a: 'We export premium Pakistani basmati rice (1121 & 1509 Sella and Steam), non-basmati rice (IRRI-6, PK-386, C-9 Sella and 100% broken), Himalayan Pink Salt and refined white salt, milling & feed wheat, feed-grade yellow corn maize, and natural white hulled sesame seeds.',
  },
  {
    q: 'What is your minimum order quantity (MOQ)?',
    a: 'We typically supply in full container loads (FCL) and bulk vessel quantities. MOQ varies by product and packing, so please share your requirement and destination and we will confirm the exact MOQ and lead time.',
  },
  {
    q: 'Which ports and Incoterms do you offer?',
    a: 'Standard shipments are FOB Port Qasim, Karachi, with CIF and C&F pricing available to most major ports worldwide. We handle documentation, inspection and container/vessel loading.',
  },
  {
    q: 'Which certifications and registrations do you hold?',
    a: 'Kassam Trading Company is REAP-registered (Rice Exporters Association of Pakistan) and a KCCI member, operating to ISO 9001, ISO 22000, HACCP and Halal standards. Third-party inspection by SGS or Bureau Veritas is available on request.',
  },
  {
    q: 'What packaging options are available?',
    a: 'We pack in PP and jute bags, BOPP printed and non-woven bags, and consumer retail packs from 1 kg to 50 kg, as well as jumbo bags and bulk. Private-label and buyer-specific packing are available across the range.',
  },
  {
    q: 'Which countries do you export to?',
    a: 'We ship to 30+ countries across the Gulf, East and West Africa, Southeast Asia, Europe and the Americas — including the UAE, Saudi Arabia, Kenya, Nigeria, Malaysia, the Philippines, the Netherlands, the UK and Canada.',
  },
  {
    q: 'How do I request a quote or product samples?',
    a: 'Use the Request a Quote form on this site, email us at ktcmktg@gmail.com, or message us on WhatsApp. Share the product, grade, quantity and destination port and we will respond with pricing. Samples are available on request.',
  },
  {
    q: 'How long has KTC been exporting?',
    a: 'Kassam Trading Company has been milling and exporting from Pakistan since 1999. We are a family-run business with our own rice mill at Port Qasim, giving buyers direct-from-source quality and consistency.',
  },
];

export const faqLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export const blogPostLd = (a, imageAbs) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: a.title,
  image: imageAbs ? [imageAbs] : undefined,
  datePublished: a.date,
  dateModified: a.date,
  author: { '@type': 'Organization', name: SITE.name, url: SITE.url },
  publisher: {
    '@type': 'Organization',
    name: SITE.name,
    logo: { '@type': 'ImageObject', url: SITE.url + '/logo.png' },
  },
  mainEntityOfPage: SITE.url + '/insights/' + a.slug,
  description: a.excerpt,
});
